import React,{ useEffect, useState } from "react";
import axios from "axios";

const Test = ({ previousStep,triggerNextStep,step,steps,datas }) => {
    let previousValue1={
        "previosuValue":"sudheer"
    }
    console.log({datas});
    const[msg, setMsg]=useState("");
    useEffect(()=>{

        console.log(previousStep);
        axios.post('http://192.168.1.128:8081/say',{
            "previousValue":previousStep.message
        })
           .then(function (response) {
            console.log(response.data.message);
            setMsg(response.data.message);
          })
      
    },[]);
    
    return (
        <li>
            
        {msg}
        </li>
        
    );
    // return (
    //     <button onClick={() => triggerNextStep({ trigger: '4' })}>Next</button>
    // );
};
export default Test;